import { useCallback, useEffect, useMemo, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRouter } from 'next/router';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import { DP3_LIST } from './config';
import css from './index.module.scss';
import { getSolarRecommand } from '@/service/solar-calculator';
import gtm from '@/utils/gtm';
import { saveCookieForShopify, saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

const Index: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const [init, setInit] = useState(false);
    const [list, setList] = useState(DP3_LIST);
    const { pageStatus } = useDP3Store();

    useEffect(() => {
        const tempData = JSON.parse(JSON.stringify(DP3_LIST)) as typeof DP3_LIST;
        const getAsynItem = async (productId: string, variantId: string, idx: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        const item = tempData[idx];
                        item.price = res?.data?.price || item.price;
                        item.compareAtPrice = res?.data?.compareAtPrice ?? (res?.data?.price || item.compareAtPrice);
                        item.inventoryQuantity = res?.data?.inventoryQuantity;
                        if (res?.data?.img) {
                            item.img = res?.data?.variantImg;
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempData?.map((item, idx) => getAsynItem(item.productId, item.variantId, idx));

        Promise.all(promises)
            .then(() => {
                setList(tempData);
                setInit(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, [locale]);

    const handlerBuyNow = useCallback(
        (title: string, variantId: string) => {
            const url = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
            saveCookieForShopify(url, locale);
            saveAICookieForShopify(url, locale);
            window.open(url);
            gtm.push({
                // event: 'uaEvent',
                // event_name: 'buy',
                // product_name: title,
                // position: 'Buy Now',
                event: 'uaEvent',
                event_name: 'checkout',
                button_name: title,
            });
            // window.open(`https://admin.shopify.com/store/ecoflow-australia/products/8311879925958/variants/${variantId}`);
            // window.open(`https://${locale}.ecoflow.com/products/ecoflow-delta-pro-3-portable-power-station?variant=${variantId}`);
        },
        [locale],
    );

    const gap = useMemo(() => {
        const innerWidth = window?.innerWidth;
        if (innerWidth > 1024) {
            return 20;
        } else {
            return 13;
        }
    }, []);
    return (
        <div className={`${css.thecomp}`}>
            <div className="dp3-spec"></div>

            {init && (
                <>
                    <div className="title">Check out these EcoFlow DELTA Pro 3 solutions for different scenarios:</div>
                    <Swiper className="swiper-container" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                        {list.map((item, idx) => (
                            <SwiperSlide className="swiper-card" key={idx}>
                                <div className="card-content">
                                    <div className="card-title">{item.title}</div>
                                    <img className="card-image" src={item.img} alt="" />
                                    <div className="card-name">{item.subTitle}</div>
                                    {item.param && <div className="card-param">{item.param}</div>}
                                    <div className="card-desc">{item.desc}</div>
                                    <div className="card-price-box">
                                        <div className="new-price">${item.price.toLocaleString()}</div>
                                        {pageStatus !== IPageStatus.statusC && item.price <= item.compareAtPrice && (
                                            <div className="old-price">${item.compareAtPrice.toLocaleString()}</div>
                                        )}
                                    </div>
                                </div>

                                <button className="card-btn" onClick={() => handlerBuyNow(item.subTitle, item.variantId)}>
                                    Buy Now
                                </button>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </>
            )}
        </div>
    );
};
export default Index;
